(function() {
  'use strict';

  const SELECTORS = {
    root: '[data-ecoseal-addon-upsells]',
    card: '[data-ecoseal-addon-card]',
    option: '[data-ecoseal-addon-option]',
    image: '[data-ecoseal-addon-image]',
    title: '[data-ecoseal-addon-title]',
    price: '[data-ecoseal-addon-price]',
    count: '[data-ecoseal-addon-count]',
    step: '[data-ecoseal-addon-step]',
    add: '[data-ecoseal-addon-add]',
    addText: '[data-ecoseal-addon-add-text]',
    quickView: '[data-ecoseal-addon-quick-view]'
  };

  const AddonUpsells = {
    init: function(root) {
      const scope = root || document;
      scope.querySelectorAll(SELECTORS.root).forEach((container) => {
        if (container.dataset.ecosealAddonInitialized === 'true') return;
        container.dataset.ecosealAddonInitialized = 'true';
        this.prepareCards(container);
        this.bind(container);
      });
    },

    prepareCards: function(container) {
      container.querySelectorAll(SELECTORS.card).forEach((card) => {
        const active = card.querySelector(`${SELECTORS.option}.is-active:not(:disabled)`) ||
          card.querySelector(`${SELECTORS.option}:not(:disabled)`);

        if (active) {
          this.selectOption(card, active);
        }

        this.updateStepper(card);
      });
    },

    bind: function(container) {
      container.addEventListener('click', (event) => {
        const option = event.target.closest(SELECTORS.option);
        if (option && container.contains(option)) {
          event.preventDefault();
          this.selectOption(option.closest(SELECTORS.card), option);
          return;
        }

        const step = event.target.closest(SELECTORS.step);
        if (step && container.contains(step)) {
          event.preventDefault();
          this.stepQuantity(step.closest(SELECTORS.card), Number(step.dataset.ecosealAddonStep));
          return;
        }

        const add = event.target.closest(SELECTORS.add);
        if (add && container.contains(add)) {
          event.preventDefault();
          this.addToCart(add.closest(SELECTORS.card), add, container);
        }
      });

      container.addEventListener('keydown', (event) => {
        const quickView = event.target.closest(SELECTORS.quickView);
        if (!quickView || !container.contains(quickView)) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        quickView.click();
      });
    },

    selectOption: function(card, option) {
      if (!card || !option || option.disabled) return;

      card.querySelectorAll(SELECTORS.option).forEach((button) => {
        button.classList.toggle('is-active', button === option);
      });

      card.dataset.variantId = option.dataset.variantId || '';

      const title = card.querySelector(SELECTORS.title);
      const price = card.querySelector(SELECTORS.price);
      const image = card.querySelector(SELECTORS.image);
      const add = card.querySelector(SELECTORS.add);
      const container = card.closest(SELECTORS.root);

      if (title && option.dataset.title) title.textContent = option.dataset.title;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (image && option.dataset.image) this.updateImage(image, option.dataset.image);
      this.updateProductUrl(card, option.dataset.variantId);
      if (add) {
        const productTitle = option.dataset.title || card.dataset.title || (container && container.dataset.labelProductFallback) || '';
        const addAriaTemplate = (container && container.dataset.labelAddAriaTemplate) || '__PRODUCT__';
        add.disabled = !card.dataset.variantId;
        add.setAttribute('aria-label', addAriaTemplate.replace('__PRODUCT__', productTitle));
      }
    },

    getVariantUrl: function(baseUrl, variantId) {
      if (!baseUrl || !variantId) return baseUrl || '';

      const separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
      return `${baseUrl}${separator}variant=${encodeURIComponent(variantId)}`;
    },

    getRootUrl: function() {
      const routes = window.theme && window.theme.routes ? window.theme.routes : {};
      const rootUrl = routes.root_url || '/';
      return rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
    },

    getCartAddUrl: function() {
      return this.getRootUrl() + '/cart/add.js';
    },

    getCartJsonUrl: function() {
      return this.getRootUrl() + '/cart.js';
    },

    updateProductUrl: function(card, variantId) {
      if (!card || !variantId) return;

      card.querySelectorAll('[data-product-base-url]').forEach((element) => {
        const nextUrl = this.getVariantUrl(element.dataset.productBaseUrl, variantId);
        if (!nextUrl) return;

        element.dataset.productUrl = nextUrl;

        if (element.tagName === 'A') {
          element.setAttribute('href', nextUrl);
        }
      });
    },

    updateImage: function(image, nextSrc) {
      if (!image || !nextSrc) return;

      const media = image.closest('.ecoseal-addon-upsell__media');
      const currentSrc = image.getAttribute('src') || '';

      if (currentSrc === nextSrc || image.currentSrc === nextSrc) {
        if (media) {
          media.classList.remove('is-loading');
          media.removeAttribute('aria-busy');
        }
        return;
      }

      const requestId = `${Date.now()}-${Math.random()}`;
      image.dataset.ecosealImageRequest = requestId;

      if (media) {
        media.classList.add('is-loading');
        media.classList.remove('is-loaded');
        media.setAttribute('aria-busy', 'true');
      }

      const preloader = new Image();
      const finish = () => {
        if (image.dataset.ecosealImageRequest !== requestId) return;

        image.src = nextSrc;

        window.requestAnimationFrame(() => {
          if (media) {
            media.classList.remove('is-loading');
            media.classList.add('is-loaded');
            media.removeAttribute('aria-busy');

            window.setTimeout(() => {
              media.classList.remove('is-loaded');
            }, 320);
          }
        });
      };

      preloader.onload = finish;
      preloader.onerror = finish;
      preloader.src = nextSrc;
    },

    stepQuantity: function(card, delta) {
      if (!card || !Number.isFinite(delta)) return;

      const stepSize = Math.max(1, Number(card.dataset.unitStep) || 1);
      const count = card.querySelector(SELECTORS.count);
      const current = Math.max(stepSize, Number(count?.textContent) || stepSize);
      const next = Math.max(stepSize, current + (delta * stepSize));

      if (count) count.textContent = String(next);
      this.updateStepper(card);
    },

    updateStepper: function(card) {
      if (!card) return;

      const stepSize = Math.max(1, Number(card.dataset.unitStep) || 1);
      const count = Math.max(stepSize, Number(card.querySelector(SELECTORS.count)?.textContent) || stepSize);

      card.querySelectorAll(SELECTORS.step).forEach((button) => {
        const delta = Number(button.dataset.ecosealAddonStep);
        button.disabled = delta < 0 && count <= stepSize;
      });
    },

    ensureBubble: function(container, count) {
      if (!container) return;

      let bubble = container.querySelector('.cart-count-bubble');
      if (!bubble && count > 0) {
        bubble = document.createElement('span');
        bubble.className = `cart-count-bubble${count >= 100 ? ' cart-count-bubble--dot' : ''}`;

        if (count < 100) {
          const inner = document.createElement('span');
          inner.setAttribute('aria-hidden', 'true');
          inner.textContent = String(count);
          bubble.appendChild(inner);
        }

        const hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = `Cart count ${count}`;
        bubble.appendChild(hidden);
        container.appendChild(bubble);
        return;
      }

      if (!bubble) return;

      if (count <= 0) {
        bubble.remove();
        return;
      }

      bubble.classList.toggle('cart-count-bubble--dot', count >= 100);
      bubble.style.display = '';

      let number = bubble.querySelector('span[aria-hidden="true"]');
      if (count >= 100) {
        if (number) number.textContent = '';
        return;
      }

      if (!number) {
        number = document.createElement('span');
        number.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(number, bubble.firstChild);
      }
      number.textContent = String(count);
    },

    updateCartBubbles: function(count) {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        if (count <= 0) {
          bubble.remove();
          return;
        }

        bubble.style.display = '';
        bubble.classList.toggle('cart-count-bubble--dot', count >= 100);

        const number = bubble.querySelector('span[aria-hidden="true"]');
        if (number) {
          number.textContent = count < 100 ? String(count) : '';
        }
      });

      this.ensureBubble(document.getElementById('cart-icon-bubble'), count);
      this.ensureBubble(document.getElementById('mobile-cart-icon-bubble'), count);
    },

    updateMiniCartSilently: function(cartData) {
      const miniCart = document.querySelector('mini-cart');
      if (!miniCart || typeof miniCart.renderContentsSilently !== 'function') return Promise.resolve();

      const cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url)
        ? window.theme.routes.cart_url
        : '/cart';
      const sections = typeof miniCart.getSectionsToRender === 'function' ? miniCart.getSectionsToRender() : [];
      const sectionIds = sections.length > 0
        ? sections.map((section) => section.id || section.section).join(',')
        : 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';

      return fetch(`${cartUrl}?sections=${encodeURIComponent(sectionIds)}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((response) => response.json())
        .then((sectionsData) => {
          miniCart.renderContentsSilently(Object.assign({}, cartData, { sections: sectionsData }));
        })
        .catch(() => {});
    },

    dispatchCartEvents: function(cartData, variantId) {
      try {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: cartData }
        }));
      } catch (error) {
        const event = document.createEvent('CustomEvent');
        event.initCustomEvent('ajaxProduct:added', true, true, { product: cartData });
        document.dispatchEvent(event);
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'ecoseal-addon-upsells',
          productVariantId: variantId,
          cartData: cartData
        });
      }
    },

    isVisible: function(element) {
      if (!element) return false;

      try {
        const rect = element.getBoundingClientRect();
        if (rect.width <= 1 && rect.height <= 1) return false;
        if (rect.bottom < 0 || rect.right < 0) return false;

        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top > viewportHeight || rect.left > viewportWidth) return false;

        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      } catch (error) {
        return false;
      }
    },

    pickCartTarget: function() {
      const candidates = [
        document.querySelector('#mobile-cart-icon-bubble .cart-count-bubble'),
        document.getElementById('mobile-cart-icon-bubble'),
        document.querySelector('#cart-icon-bubble .cart-count-bubble'),
        document.getElementById('cart-icon-bubble')
      ];

      for (const candidate of candidates) {
        if (this.isVisible(candidate)) return candidate;
      }

      const fallbacks = [
        document.querySelector('.cart-count-bubble'),
        document.querySelector('.icon-cart'),
        document.querySelector('[data-cart-toggle]'),
        document.querySelector('a[href*="/cart"]')
      ];

      for (const fallback of fallbacks) {
        if (this.isVisible(fallback)) return fallback;
      }

      return null;
    },

    bumpCartTarget: function(target) {
      if (!target) return;

      const element = target.querySelector ? (target.querySelector('.cart-count-bubble') || target) : target;
      element.classList.add('cart-bump');
      window.setTimeout(() => {
        element.classList.remove('cart-bump');
      }, 300);
    },

    flyToCart: function(card) {
      try {
        const image = card && card.querySelector('.ecoseal-addon-upsell__media img');
        if (!image) return;

        const target = this.pickCartTarget();
        if (!target) return;

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.bumpCartTarget(target);
          return;
        }

        const imageRect = image.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const clone = image.cloneNode(true);

        clone.className = `${clone.className ? `${clone.className} ` : ''}iu-fly-clone`;
        clone.style.left = `${imageRect.left}px`;
        clone.style.top = `${imageRect.top}px`;
        clone.style.width = `${imageRect.width}px`;
        clone.style.height = `${imageRect.height}px`;
        clone.style.opacity = '0.9';
        clone.style.transform = 'translate3d(0,0,0)';

        document.body.appendChild(clone);
        clone.offsetHeight;

        const deltaX = (targetRect.left + (targetRect.width / 2)) - (imageRect.left + (imageRect.width / 2));
        const deltaY = (targetRect.top + (targetRect.height / 2)) - (imageRect.top + (imageRect.height / 2));

        clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.3)`;
        clone.style.opacity = '0.2';

        let cleanedUp = false;
        const cleanup = () => {
          if (cleanedUp) return;
          cleanedUp = true;
          if (clone && clone.parentNode) clone.parentNode.removeChild(clone);
          this.bumpCartTarget(target);
        };

        clone.addEventListener('transitionend', cleanup, { once: true });
        window.setTimeout(cleanup, 700);
      } catch (error) {}
    },

    addToCart: function(card, button, container) {
      if (!card || !button || button.disabled) return;

      const variantId = card.dataset.variantId;
      const quantity = Number(card.querySelector(SELECTORS.count)?.textContent) || Number(card.dataset.unitStep) || 1;
      const label = button.querySelector(SELECTORS.addText);
      const originalText = label ? label.textContent : '';

      if (!variantId) return;

      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = container.dataset.labelAdding || '';

      fetch(this.getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message || 'Add to cart failed');
          }

          return fetch(this.getCartJsonUrl(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
        })
        .then((response) => response.json())
        .then((cartData) => {
          this.updateCartBubbles(cartData.item_count);
          return this.updateMiniCartSilently(cartData).then(() => cartData);
        })
        .then((cartData) => {
          this.dispatchCartEvents(cartData, variantId);
          this.flyToCart(card);

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          if (label) label.textContent = container.dataset.labelAdded || '';

          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-added');
            if (label) label.textContent = originalText || container.dataset.labelAdd || '';
          }, 1800);
        })
        .catch((error) => {
          if (window.Shopify && window.Shopify.designMode) {
            console.warn('[EcoSeal Addon Upsells] Could not add item', error);
          }

          button.disabled = false;
          button.classList.remove('is-loading');
          if (label) label.textContent = originalText || container.dataset.labelAdd || '';
        });
    }
  };

  window.EcoSealAddonUpsells = AddonUpsells;

  const initialize = function(event) {
    AddonUpsells.init(event && event.target instanceof Element ? event.target : document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('quickview:loaded', initialize);
  document.addEventListener('product-info:loaded', initialize);
})();
